import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { homeMapper } from '@/mappers';
import { loadAbort, buildStrapiUrl } from '@/utils';
import type { StrapiHomeModel, StrapiSingleResponseModel } from '@/interfaces/model';
import type { Home, StrapiListRequest } from '@/interfaces/strapi';

export const getHomeStrapi = ({ populate }: StrapiListRequest): UseApiCall<Home> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/home',
		populate,
	});

	return {
		call: strapiInstance.get<Home>(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const parsed = JSON.parse(raw) as StrapiSingleResponseModel<StrapiHomeModel>;
					return homeMapper(parsed.data);
				},
			],
		}),
		controller,
	};
};
